import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Bildirimler',
  pageTitle: 'Bildirimler',
  pageDescription: 'Bildirimlerinizi görüntüleyin ve yönetin',
  settingsTitle: 'Bildirim Ayarları',
  settingsPageTitle: 'Bildirim Ayarları',
  settingsPageDescription: 'Bildirim tercihlerinizi yönetin',
  settings: 'Ayarlar',
  markAsRead: 'Okundu olarak işaretle',
  markAllAsRead: 'Tümünü okundu olarak işaretle',
  delete: 'Sil',
  more: 'daha fazla',
  noNotifications: 'Bildirim yok',
  emptyDescription: 'Henüz bildiriminiz yok',
  errorLoading: 'Bildirimler yüklenirken hata oluştu',
  errorLoadingSettings: 'Bildirim ayarları yüklenirken hata oluştu',
  tryAgain: 'Lütfen daha sonra tekrar deneyin',
  enableNotifications: 'Bildirimleri Etkinleştir',
  enablePromptMessage: 'En son incelemeler, beğeniler ve takiplerden haberdar olmak için bildirimleri etkinleştirin.',
  remindLater: 'Daha sonra hatırlat',
  enable: 'Etkinleştir',
  stayUpdated: 'Güncel Kalın',
  enableDescription: 'Yeni incelemeler, beğeniler ve takiplerden haberdar olmak için bildirimleri etkinleştirin.',
  pushNotifications: 'Anlık Bildirimler',
  pushDescription: 'Cihazınızda bildirim alın',
  emailNotifications: 'E-posta Bildirimleri',
  emailDescription: 'E-posta yoluyla bildirim alın',
  enableAllNotifications: 'Tüm Bildirimleri Etkinleştir',
  masterToggleDescription: 'Tüm bildirimleri aç/kapat',
  notificationTypes: 'Bildirim Türleri',
  types: {
    reviewLiked: 'İnceleme Beğenildi',
    reviewLikedDescription: 'Biri incelemenizi beğendiğinde bildirim alın',
    newPlaceReviews: 'Yeni Mekan İncelemeleri',
    newPlaceReviewsDescription: 'Yeni bir mekan incelendiğinde bildirim alın',
    newFoodReviews: 'Yeni Yemek İncelemeleri',
    newFoodReviewsDescription: 'Yeni bir yemek incelendiğinde bildirim alın',
    newReviewCreated: 'Yeni İnceleme Oluşturuldu',
    newReviewCreatedDescription: 'Yeni bir inceleme oluşturulduğunda bildirim alın',
    userFollowed: 'Kullanıcı Takip Edildi',
    userFollowedDescription: 'Bir kullanıcı sizi takip ettiğinde bildirim alın',
  },
}; 

export default notificationsTranslations;